var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import styles from "./SurveyHeader.module.scss";
import { getSettings } from "../../constants/setting";
import { useDispatch, useSelector } from "react-redux";
import { currentLanguage, minimizeSurvey } from "../../stores/reducers/chatReducer";
import { getTextColor } from "../../helper";
import { getTranslation } from "../../constants/setting";
import FieldGroupThumb from "../FieldGroupThumbs/FieldGroupThumbs";
import FieldGroupStarRating from "../FieldGroupStarRating/FieldGroupStarRating";
import FieldGroupSmiley from "../FieldGroupSmiley/FieldGroupSmiley";
import chatBotApi from "../../api/chatbot";
import { getHostname } from "../../../embedded/helper";
import { Form } from "react-bootstrap";
var SurveyHeader = function () {
    var dispatch = useDispatch();
    var language = useSelector(currentLanguage);
    var _b = getSettings(), survey_primary_question = _b.survey_primary_question, primary_color = _b.primary_color, survey_url = _b.survey_url, bot_id = _b.bot_id, subsite = _b.subsite;
    var RESPONSE_TYPE_THUMBS_UP_OR_DOWN = 'thumbs_up_or_down';
    var RESPONSE_TYPE_SMILEY_FACE_RATING = 'smiley_face_rating';
    var RESPONSE_TYPE_STAR_RATING = 'star_rating';
    var _j = useState(survey_primary_question), primaryQuestion = _j[0], setPrimaryQuestion = _j[1];
    var _k = useState(false), initComponent = _k[0], setInitComponent = _k[1];
    var isMobile = function () {
        return window.innerWidth < 469 || window.innerHeight < 469;
    };
    var onClickMinimize = function () {
        dispatch(minimizeSurvey(true));
    };
    var onClicked = function (value) {
        dispatch(minimizeSurvey(true));
        var params = {
            bot_id: bot_id,
            referrer: subsite || getHostname(window.location.origin),
            language: language
        };
        if (value !== null) {
            // @ts-ignore
            params.auto_submit = 1;
            // @ts-ignore
            params.answer = value;
        }
        // @ts-ignore
        var queryString = new URLSearchParams(params).toString();
        window.open("".concat(survey_url, "?").concat(queryString), "_blank");
    };
    var loadSetting = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, chatBotApi.getBotSetting(language).then(function (response) {
                        setPrimaryQuestion(response.data.survey_primary_question);
                    }).catch(function (err) {
                        var _b;
                        console.error((_b = err.response.data) === null || _b === void 0 ? void 0 : _b.message);
                        console.error(err.response.status === 404 ? 'Invalid chatbot id' : 'something went wrong!');
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (initComponent) {
            loadSetting();
        }
    }, [language]);
    useEffect(function () {
        setInitComponent(true);
    }, []);
    return _jsxs("div", __assign({ className: styles.header, style: {
            backgroundColor: primary_color,
            color: getTextColor(primary_color)
        } }, { children: [_jsxs("div", __assign({ className: styles.baseHeader }, { children: [_jsx("div", __assign({ className: styles.question, style: {
                            color: getTextColor(primary_color)
                        } }, { children: primaryQuestion === null || primaryQuestion === void 0 ? void 0 : primaryQuestion.text })), (primaryQuestion === null || primaryQuestion === void 0 ? void 0 : primaryQuestion.response_type) === RESPONSE_TYPE_THUMBS_UP_OR_DOWN &&
                        _jsx(FieldGroupThumb, { onClicked: onClicked }), (primaryQuestion === null || primaryQuestion === void 0 ? void 0 : primaryQuestion.response_type) === RESPONSE_TYPE_SMILEY_FACE_RATING &&
                        _jsx(FieldGroupSmiley, { onClicked: onClicked }), (primaryQuestion === null || primaryQuestion === void 0 ? void 0 : primaryQuestion.response_type) === RESPONSE_TYPE_STAR_RATING &&
                        _jsx(FieldGroupStarRating, { onClicked: onClicked })] })), (primaryQuestion === null || primaryQuestion === void 0 ? void 0 : primaryQuestion.response_type) !== RESPONSE_TYPE_THUMBS_UP_OR_DOWN &&
                (primaryQuestion === null || primaryQuestion === void 0 ? void 0 : primaryQuestion.response_type) !== RESPONSE_TYPE_SMILEY_FACE_RATING &&
                (primaryQuestion === null || primaryQuestion === void 0 ? void 0 : primaryQuestion.response_type) !== RESPONSE_TYPE_STAR_RATING &&
                _jsx("a", __assign({ href: "#", onClick: function () { return onClicked(null); }, className: styles.surveyLink, style: {
                        backgroundColor: getTextColor(primary_color),
                        color: getTextColor(getTextColor(primary_color))
                    } }, { children: getTranslation('chatbot.start_survey', language) })), _jsxs("button", __assign({}, { tabIndex: 0 }, { id: "close_survey_header", style: {
                    color: getTextColor(primary_color)
                }, className: styles.close, onClick: onClickMinimize }, { children: [isMobile() ? getTranslation('chatbot.close') : _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", width: 15, fill: getTextColor(primary_color) }, { children: _jsx("path", { d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" }) })), _jsx(Form.Label, __assign({ htmlFor: "close_survey_header", className: "".concat(styles.srOnly) }, { children: getTranslation('chatbot.close_survey_header') }))] }))] }));
};
export default SurveyHeader;
